module.exports = __webpack_public_path__ + "img/word.8836d3f9.svg";